/* import __COLOCATED_TEMPLATE__ from './same-day-deposit-confirmation-modal-content.hbs'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();